import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M5.293 6L.646 1.354l.708-.708L6 5.293 10.646.646l.708.708L6.707 6l4.647 4.646-.707.708L6 6.707l-4.646 4.647-.708-.707L5.293 6z" /></svg>;